<template>
  <div class="addgd-component-container">
    <div class="column-item">
      <div class="title-item">工单类型</div>
      <div class="class-item">
        <div class="item" :class="item.Id == classId ? 'active' : ''" v-for="(item, index) in classList" :key="index" @click="handleChooseClass(item.Id)">{{ item.CnClassName }}</div>
      </div>
    </div>
    <div class="column-item">
      <div class="title-item">详细问题</div>
      <div class="textarea">
        <textarea ref="descTextarea" v-model="desc" maxlength="200" rows="6" placeholder="请输入你的问题"></textarea>
      </div>
    </div>
    <div class="submit-btn" @click="handleSubmit">
      <van-loading v-if="submiting" size="20" color="#5783fc" />
      <span v-else>提交</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "ContentGdAddComponent",
  data() {
    return {
      classList: [],
      classId: 0,
      desc: '',
      submiting: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  watch: {
    '$route'(val) {
      if (val.name == 'Content' && val.query.pageType == '2' && val.query.page == 'add' && val.query.order_id) {
        this.desc = '订单ID：' + this.$route.query.order_id + '。\n'
        this.$refs.descTextarea.focus()
      }
    }
  },
  mounted() {
    this.handleGetClassList()
    if (this.$route.query && this.$route.query.order_id) {
      this.desc = '订单ID：' + this.$route.query.order_id + '。\n'
      this.$refs.descTextarea.focus()
    }
  },
  methods: {
    handleChooseClass(id) {
      this.classId = id
    },
    async handleGetClassList() {
      var res = await this.$API.announcedCategoryList.post()
      if (res.info && res.info.length > 0) {
        this.classId = res.info[0].Id
      }
      this.classList = res.info
    },
    async handleSubmit() {
      const { classId, desc, submiting } = this
      if (submiting) {
        return
      }
      if (!desc) {
        this.$toast('请输入你的问题')
        return
      }
      const params = {
        Switch: 1,
        Desc: desc,
        ClassId: classId
      }
      this.submiting = true
      var res = await this.$API.addTickets.post(params)
      this.submiting = false
      if (res.error == 0) {
        this.$toast.success(res.info)
      } else {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.column-item {
  margin-bottom: 20px;
  overflow: hidden;
  .title-item {
    padding-left: 18px;
    position: relative;
    height: 28px;
    line-height: 28px;
    font-size: 18px;
    font-weight: 500;
    color: #393942;
    margin-bottom: 15px;
    &::before {
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      width: 3px;
      height: 20px;
      border-radius: 0 2px 2px 0;
      background-color: #5783fc;
    }
  }
  .class-item {
    float: left;
    overflow: hidden;
    .item {
      cursor: pointer;
      height: 25px;
      padding: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #f5f7fa;
      color: #64748b;
      font-size: 12px;
      margin-right: 10px;
      margin-bottom: 10px;
      border-radius: 13px;
      &.active {
        background-color: #5783fc;
        color: #fff;
      }
    }
  }
  .textarea {
    padding: 15px;
    border-radius: 5px;
    background-color: #f7f7f7;
    height: 260px;
  }
}
.submit-btn {
  margin: 20px auto 50px;
  width: 75px;
  height: 25px;
  border: 1px solid #5783fc;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5783fc;
  font-weight: 500;
  cursor: pointer;
}
</style>